import { Component, computed, inject } from '@angular/core';
import { NavigationEnd, PRIMARY_OUTLET, Router, RouterOutlet } from '@angular/router';
import {
  LucideIconInput,
  LucideMegaphone,
  LucideSwords,
  LucideUserCheck,
  LucideUserPlus,
  LucideUsers,
} from '@lucide/angular';
import {
  Icon,
  Sidebar,
  SidebarGroup,
  SidebarMenuItem,
  SidebarMenuSubItem,
} from '@squad-area/design-system';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs';
import { AccessTokenStore } from '../../stores/access-token.store';

interface SidebarGroupItem {
  label?: string;
  items: SidebarItem[];
}

interface SidebarItem {
  label: string;
  path: string;
  icon?: LucideIconInput;
  disabled?: boolean;
  subItems?: SidebarItem[];
}

@Component({
  selector: 'app-sidebar-layout',
  imports: [RouterOutlet, Icon, Sidebar, SidebarGroup, SidebarMenuItem, SidebarMenuSubItem],
  templateUrl: './sidebar-layout.html',
  styleUrl: './sidebar-layout.css',
})
export class SidebarLayout {
  private readonly router = inject(Router);
  private readonly accessTokenStore = inject(AccessTokenStore);

  private readonly isAuthenticated = this.accessTokenStore.isAuthenticated;

  protected readonly groups = computed<SidebarGroupItem[]>(() => [
    {
      items: [
        {
          label: 'Actualités',
          path: 'articles',
          icon: LucideMegaphone,
          disabled: false,
        },
        {
          label: 'Armes',
          path: 'weapons',
          icon: LucideSwords,
          disabled: false,
        },
        {
          label: 'Trouver un mate',
          path: 'find-mates',
          icon: LucideUserPlus,
          disabled: false,
        },
      ],
    },
    {
      label: 'Connexion requise',
      items: [
        {
          label: 'Rejoindre une squad',
          path: 'join-squad',
          icon: LucideUserCheck,
          disabled: !this.isAuthenticated(),
        },
        {
          label: 'Créer une squad',
          path: 'create-squad',
          icon: LucideUsers,
          disabled: !this.isAuthenticated(),
        },
      ],
    },
    /*{
      label: 'Premium requis',
      items: [
        {
          label: 'Conseils de pro',
          path: 'pro',
          icon: LightbulbIcon,
          disabled: true,
        },
      ],
    },*/
  ]);

  protected readonly currentPath = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e) => e.urlAfterRedirects),
      startWith(this.router.url),
      // segments[0] = jeu (ex: wz), segments[1] = page (ex: articles)
      map((url) => this.router.parseUrl(url).root.children[PRIMARY_OUTLET]?.segments[1]?.path),
    ),
  );
}
